////////LIBRARY/////////
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { shallowEqual, useSelector } from 'react-redux'
import Loader from 'react-loader-spinner'
///////COMPONENTS///////
import UseModalPosY from '../../hooks/UseModalPosY'

/////////STYLED/////////
const LoadingWrapper = styled.div`
	position: fixed;
	top: ${(props) => props.postop + 'px'};
	top: 0;
	left: 0;
	display: flex;
	justify-items: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
	z-index: 53;
`
const LoadingBackground = styled.div`
	position: absolute;
	background-color: rgba(255, 255, 255, 0.7);
	z-index: 100;
	width: 100vw;
	height: 100vh;
`
const ModalWrapper = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	max-height: 90%;
	overflow-y: auto;
	left: 50%;
	top: 50%;
	z-index: 200;
	transform: translate(-50%, -50%);
`
const TitleLoading = styled.div`
	font-size: ${(props) => props.theme.font.fxxxl};
	margin-bottom: 20px;
	font-weight: bold;
`
/////////STYLED/////////

const Loading = () => {
	const { globalLoading } = useSelector(
		(state) => ({
			globalLoading: state.globalLoading.loading,
		}),
		shallowEqual
	)

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (globalLoading) {
			document.body.style.overflow = 'hidden'
			document.body.style.paddingRight = '10px'
		}
		return () => {
			document.body.style.overflow = ''
			document.body.style.paddingRight = ''
		}
	}, [globalLoading])

	const [winPos] = UseModalPosY(globalLoading)
	let posTop = winPos.windowPageYOffset

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			{globalLoading && (
				<LoadingWrapper postop={posTop}>
					<ModalWrapper loader>
						<TitleLoading>Chargement en cours</TitleLoading>
						<Loader type="ThreeDots" color="#0885D5" height={150} width={150} />
					</ModalWrapper>
					<LoadingBackground postop={winPos} />
				</LoadingWrapper>
			)}
		</>
	)
}

Loading.propTypes = {}

Loading.defaultPropTypes = {}

export default Loading
